'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.weeksSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/weeksSince.js
// module id = 362
// module chunks = 0